//@flow
import * as Immutable from 'immutable';

import { CreatePjpRequest } from 'common/models/flow/CreatePjpRequest';
import type { CreatePjpRequestModelType } from 'common/models/flow/CreatePjpRequest';

import { RidersData } from './RidersData';
import { OutletsData } from './OutletsData';
import { PjPlanConfiguration } from './PjPlanConfiguration';
import {
    validatable,
    validateAll,
    softValidateAll
} from 'common/utils/ValidationUtil';

@validatable
class InternalCreatePjpRequest extends CreatePjpRequest {
    static fromJS(json: CreatePjpRequestModelType): InternalCreatePjpRequest {
        const state: Object = Object.assign({}, json);
        state.outletsData = OutletsData.fromJS(state.outletsData);
        state.ridersData = RidersData.fromJS(state.ridersData);
        state.configuration = PjPlanConfiguration.fromJS(state.configuration);
        return new this(Immutable.Map(state));
    }

    get outletsData(): OutletsData {
        return this._state.get('outletsData');
    }

    get ridersData(): RidersData {
        return this._state.get('ridersData');
    }

    get configuration(): PjPlanConfiguration {
        return this._state.get('configuration');
    }

    @softValidateAll
    hasValidationErrors(): boolean {
        const { configuration } = this;
        if (configuration) {
            return configuration.hasValidationErrors();
        }
        return false;
    }

    @validateAll
    setAllValidationErrors(): this {
        let { configuration } = this;
        if (configuration) {
            configuration = configuration.setAllValidationErrors();
        }
        return this.setConfiguration(configuration);
    }

    setConfiguration(configuration: PjPlanConfiguration): this {
        return super.setConfiguration(configuration);
    }
}

export { InternalCreatePjpRequest as CreatePjpRequest };
